import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SscClientService, SscRequest, SscResponse } from '@sla-ng/core';
import { map } from 'rxjs/operators';
import { IDependencyVersion } from '../../models/dependency-version.model';
import { IVersion } from '../../models/version.model';
import { IAdditionalInfo } from './../../models/additional-info.model';

@Component({
    selector: 'mat-version-dialog',
    templateUrl: './version-dialog.component.html',
    styleUrls: [ './version-dialog.component.scss' ],
})
export class VersionDialogComponent implements OnInit {
    public displayedVersions: IDependencyVersion[];
    public additionalInfo: IAdditionalInfo[];

    public initialVersions: IDependencyVersion[];
    public allVersions: IDependencyVersion[];

    public showAll: boolean = false;
    public displayedColumns: string[] = [ 'name', 'version' ];

    public additionalInfoColumns: string[] = [ 'label', 'value' ];

    constructor(
        public myTranslation: TranslateService,
        public mySscClientService: SscClientService,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        @Inject(MAT_DIALOG_DATA) public data: { additionalInfo: IAdditionalInfo[], packageJson: { default: any }, version: IVersion, hiddenInfos: string[] },
    ) {
    }

    public ngOnInit(): void {
        void this.createTable();
    }

    public async createTable(): Promise<void> {
        this.allVersions = [];
        this.displayedVersions = [];

        this.additionalInfo = this.data.additionalInfo;

        this.initialVersions = [];
        console.log(JSON.stringify(this.data));

        this.initialVersions.push({
            name: this.myTranslation.instant('sla.ui-material.version.application-name.label'),
            version: this.data.packageJson[ 'name' ],
        });

        if (!this.data.hiddenInfos.includes('version')) {
            this.initialVersions.push({
                name: this.myTranslation.instant('sla.ui-material.version.application-version.label'),
                version: this.data.packageJson.default[ 'version' ],
            });
        }

        if (this.data.version) {
            this.initialVersions.push({
                name: this.myTranslation.instant('sla.ui-material.version.application-build-timestamp.label'),
                version: this.data.version.timestamp,
            });
        }

        if (!this.data.hiddenInfos.includes('ip')) {
            this.initialVersions.push({
                name: this.myTranslation.instant('sla.ui-material.version.ip.label'),
                version: await this.getCurrentIP(),
            });
        }

        this.allVersions = [ ...this.initialVersions ];
        this.displayedVersions = [ ...this.initialVersions ];

        if (!this.data.hiddenInfos.includes('dependencies')) {
            for (const key in this.data.packageJson.default.dependencies) {
                if (key.indexOf('@sla-ng/') > -1) {
                    this.allVersions.push({
                        name: key,
                        version: this.data.packageJson.default.dependencies[ key ],
                    });
                }
            }
        }
    }

    public resetCache(): void {
        localStorage.clear();
        window.location.reload();
    }

    public toggleVersionDetail(): void {
        this.showAll = !this.showAll;
        if (this.showAll) {
            this.displayedVersions = [ ...this.allVersions ];
        } else {
            this.displayedVersions = [ ...this.initialVersions ];
        }
    }

    private async getCurrentIP(): Promise<string> {
        const request: SscRequest = new SscRequest();
        request.aFunction = 'getmyip';
        request.aModule = 'system';
        return await this.mySscClientService.call(request, undefined, true)
            .pipe(map((result: SscResponse) => result.sscresponse.data.ip)).toPromise().catch(() => null);
    }
}
